'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { ToggleGroup, ToggleGroupItem } from '../../components';
import { useTableFilters } from '../useTableFilters';
import type { ComponentProps } from 'react';
import type { BaseTableFilterProps, FilterOption } from './types';
export interface ToggleGroupTableFilterProps extends BaseTableFilterProps {
  defaultValue?: FilterOption['value'];
  filterOptions: readonly FilterOption[];
  searchParam: string;
  variant?: 'toggleGroup';
  componentProps?: Omit<Partial<ComponentProps<typeof ToggleGroup>>, 'defaultValue'>;
  groups?: never;
  placeholder?: never;
  value?: never;
  fromDateParam?: never;
  toDateParam?: never;
}
export function ToggleGroupTableFilter(t0) {
  const $ = _c(21);
  const {
    className,
    searchParam,
    searchParamsToClearOnChange,
    componentProps,
    filterOptions,
    defaultValue,
    filterType: t1
  } = t0;
  const filterType = t1 === undefined ? "rsc" : t1;
  const searchParams = useSearchParams();
  const {
    updateFilterValue
  } = useTableFilters(filterType);
  const firstOptionValue = filterOptions?.[0]?.value;
  let t2;
  if ($[0] !== searchParam || $[1] !== searchParams) {
    t2 = searchParams?.get(searchParam);
    $[0] = searchParam;
    $[1] = searchParams;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const urlValue = t2;
  const [selectedValue, setSelectedValue] = useState(defaultValue || firstOptionValue);
  let t3;
  let t4;
  if ($[3] !== defaultValue || $[4] !== firstOptionValue || $[5] !== urlValue) {
    t3 = () => {
      setSelectedValue(urlValue || defaultValue || firstOptionValue);
    };
    t4 = [urlValue, defaultValue, firstOptionValue];
    $[3] = defaultValue;
    $[4] = firstOptionValue;
    $[5] = urlValue;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  if (!filterOptions) {
    return null;
  }
  const valueToString = _temp;
  let t5;
  if ($[8] !== searchParam || $[9] !== searchParamsToClearOnChange || $[10] !== updateFilterValue) {
    t5 = function handleChange(value_0) {
      const effectiveValue = value_0 === "__null__" ? "" : value_0;
      setSelectedValue(value_0);
      updateFilterValue(searchParam, effectiveValue, searchParamsToClearOnChange);
    };
    $[8] = searchParam;
    $[9] = searchParamsToClearOnChange;
    $[10] = updateFilterValue;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleChange = t5;
  const t6 = valueToString(selectedValue);
  let t7;
  if ($[12] !== filterOptions) {
    let t8;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = filterOption => <ToggleGroupItem key={valueToString(filterOption.value)} value={valueToString(filterOption.value)}>{filterOption.label}</ToggleGroupItem>;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    t7 = filterOptions.map(t8);
    $[12] = filterOptions;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[15] !== className || $[16] !== componentProps || $[17] !== handleChange || $[18] !== t6 || $[19] !== t7) {
    t8 = <ToggleGroup className={className} variant="unbounded" {...componentProps} onValueChange={handleChange} type="single" value={t6}>{t7}</ToggleGroup>;
    $[15] = className;
    $[16] = componentProps;
    $[17] = handleChange;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
function _temp(value) {
  if (value === null || value === undefined || value === "") {
    return "__null__";
  }
  return String(value);
}